import { cva } from 'class-variance-authority';

export const cvaRadioGroup = cva([
  'RadioGroupStyles-cvaRadioGroup',
  'overflow-clip',
]);

export const cvaRadioGroupBox = cva(
  ['RadioGroupStyles-cvaRadioGroupBox', 'flex justify-between items-center'],
  {
    variants: {
      type: {
        primary: ['border-b-[1px] border-cSecondaryGray'],
        secondary: ['rounded-[0.8rem] mb-0.8'],
      },
      bg: {
        gray: ['bg-cSecondaryGray'],
        darkGray: ['bg-cDarkGray'],
      },
    },
  }
);

export const cvaRadioGroupItemWrapper = cva(
  ['RadioGroupStyles-cvaRadioGroupItemWrapper', 'w-full'],
  {
    variants: {
      type: {
        primary: ['h-2.4'],
        secondary: [''],
      },
    },
  }
);

export const cvaRadioGroupCardInfo = cva(
  [
    'RadioGroupStyles-cvaRadioGroupCardInfo',
    'flex gap-1.2 items-center',
    'text-m-sb',
    'h-fit',
  ],
  {
    variants: {
      type: {
        primary: [''],
        secondary: [''],
      },
      cars: {
        true: [
          '[&>div]:flex [&>div]:flex-col [&>div]:gap-0.4 [&>div]:items-start text-left',
          'text-[#7C7B83] text-[1.4rem]',
        ],
        false: ['items-center'],
      },
    },
  }
);

export const cvaRadioGroupItem = cva(
  [
    'RadioGroupStyles-cvaRadioGroupItem',
    'flex',
    //  'size-[2.4rem]',
    'w-full',
  ],
  {
    variants: {
      type: {
        primary: ['py-1.4'],
        secondary: ['p-1.6'],
      },
      cars: {
        true: ['flex-row-reverse gap-1.2 justify-end relative'],
        false: ['items-center justify-between'],
      },
    },
    defaultVariants: {
      cars: false,
    },
  }
);

export const cvaRadioGroupCircle = cva([
  'RadioGroupStyles-cvaRadioGroupCircle',
  'w-2.4 min-w-2.4 h-2.4',
  'border-[3px] border-cGray rounded-full',
  'block',
]);
